<template>
  <el-dialog v-dialogDrag :visible.sync="syncMajorRoleDlg" :before-close="syncMajorRoleClose" :close-on-click-modal="false"
    :close-on-press-escape="false" :title="syncMajorRoleTitle" width="500px">
    <el-form ref="syncMajorRoleForm" :model="syncMajorRoleForm" :rules="rules" size="small">
      <el-form-item label="同步结果" prop="syncType">
        <el-radio-group v-model="syncMajorRoleForm.syncType">
          <el-radio :label="1">合并</el-radio>
          <el-radio :label="0">覆盖</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="type == 'major'" label="请选择同步的专业" prop="specIdList">
        <el-select v-model="syncMajorRoleForm.specIdList" style="width: 100%" filterable multiple size="small">
          <el-option v-for="(item, specId) in specList" :key="specId" :value="item.specId" :label="item.specName">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <synchronization-role
      v-if="type !== 'major'"
      ref="synchronizationRole"
      :type="type"
      :userList="[]"
      :roleID="roleID"
      @updateRight="selectedSysRoleChanged"
    ></synchronization-role>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="syncMajorRoleClose">取 消</el-button>
      <el-button v-preventReClick type="primary" size="small" @click="getContain">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
const newForm = () => ({
  specIdList: [],
  syncType: 1
});
import priviService from "@/CommonDP/service/privi-service";
import roleService from "@/CommonDP/service/admin/role-service";
import synchronizationRole from '@/CommonDP/components/chooseMember/component/synchronizationRole.vue';
import { mapState } from "vuex";
export default {
  components: { synchronizationRole },
  props: {
    roleID: {
      type: String,
      default: ''
    },
    folderArea: {
      type: String,
      default: ''
    },
    parentRoleID: {
      type: String,
      default: ''
    },
    templateSpecId: {
      type: String,
      default: ''
    },
    catalogueType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      syncMajorRoleDlg: false,
      syncMajorRoleTitle: '同步到其他专业',
      syncMajorRoleForm: newForm(),
      rules: {
        specIdList: [{ required: true, message: "请选择同步的专业", trigger: "change" }]
      },
      specList: [],
      type: 'major'
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  methods: {
    async showDlg(val) {
      this.type = val;
      this.syncMajorRoleDlg = true;
      this.syncMajorRoleForm = newForm();
      this.getPrjSpecList();
      this.syncMajorRoleTitle = '同步到其他专业';
      if (this.type !== 'major') {
        this.syncMajorRoleTitle = '同步到其他角色';
        await this.$nextTick(() => {});
        this.$refs.synchronizationRole.getRoleListFlow();
      }
    },
    syncMajorRoleClose() {
      this.syncMajorRoleDlg = false;
      this.$refs.syncMajorRoleForm.resetFields();
    },
    // 获取专业
    async getPrjSpecList() {
      const res = await priviService.queryPrjSpecList(this.enterpriseId);
      this.specList = res.data.filter(({ templateSpecId, specId }) => templateSpecId !== 'PRJ_ROLE_MENU_9999' && templateSpecId !== 'PM' && specId !== this.parentRoleID);
    },
    selectedSysRoleChanged(type, roleList) {
      this.syncMajorRoleForm.specIdList = roleList.map(item => item.roleId);
    },
    // 项目专业添加自定义角色
    async getContain() {
      await this.$refs.syncMajorRoleForm.validate();
      if (!this.syncMajorRoleForm.specIdList.length) {
        this.$error("请勾选目标角色");
        return;
      }
      const { syncMajorRoleForm: { specIdList, syncType }, enterpriseId } = this;
      if (this.folderArea !== '3') {
        const params = {
          roleIdList: specIdList,
          syncType,
          enterpriseId,
          specId: this.parentRoleID,
          folderArea: parseInt(this.folderArea),
          specType: this.roleID
        };
        await roleService.syncProfessionPermissionList(params);
      } else {
        const params = {
          specIdList,
          syncType,
          enterpriseId,
          folderId: this.catalogueType,
          templateSpecId: this.templateSpecId,
          roleId: this.roleID
        };
        await roleService.syncProductAreaRolePermission(params);
      }
      await this.$message({ type: "success", message: "已提交修改,处理完毕" });
      await this.syncMajorRoleClose();
      this.$emit('getFinishedProductArea');
    }
  }

};
</script>

<style></style>
